import * as t from "io-ts";
import { FinanceRate } from "./FinanceRate";
import { Metadata } from "./Metadata";

export const Rate = t.intersection([
  t.type({
    finance_rates: t.array(FinanceRate),
  }),
  t.partial({
    id: t.string,
    metadata: Metadata,
  }),
]);

export interface Rate {
  id?: string;
  finance_rates: Array<FinanceRate>;
  metadata?: Metadata;
}
